import { PixoSpatial } from '../../model/Pixospatial';
import { AnyHandler } from '../../types/@types/sl-v-types';
import * as d3 from 'd3';
export type D3SelectedGroup = d3.Selection<SVGGElement, any, HTMLElement, any>;
export type D3SelectedElement = d3.Selection<any, any, HTMLElement, any>;

export interface IDrawer {
  drawWidth: number;
  drawHeight: number;
  spatialContext: PixoSpatial;
}

export interface IDrawContext {
  enabled: boolean;
  drawWidth: number;
  drawHeight: number;
  itemElement?: D3SelectedElement;
  pixo: PixoSpatial;
}

export type EventMap = {
  touchStart?: AnyHandler,
  touchMove?: AnyHandler,
  touchEnd?: AnyHandler,
  mouseDown?: AnyHandler,
  mouseMove?: AnyHandler,
  mouseUp?: AnyHandler,
  mouseEnter?: AnyHandler,
  click?: AnyHandler,
  dblClick?: AnyHandler
}

export interface IMapInteraction {
  enabled: Boolean;
  context: IDrawer;
  interactionGroup?: D3SelectedGroup;
  pixo: PixoSpatial;
  Enable(context: IDrawer, drawRect: D3SelectedGroup, handler: AnyHandler,params?:any): void;
  TogglePausing(onOrOff: boolean): void;
  Disable(): void;
}




export function MakeInteractionGroup(context: IDrawContext, drawRect: D3SelectedGroup, eMap: EventMap): D3SelectedElement {
  const group = d3.select(drawRect.node().parentElement)

  for (const e of Object.keys(eMap)) {

    group.on(e.toLowerCase(), (event: any) => {

      if (event !== undefined) {
        if (event.target !== group.node()) {
          return;
        }
        if (event.cancellable) {
          event.preventDefault();
        }
      }
      if (d3.event?.cancelable === true) {
        d3.event.preventDefault();
        if (d3.event.target !== group.node()) return;
        eMap[e](d3.event);
      }
    });
  }
  return group as D3SelectedElement;
}
export function RemoveInteractionGroup(group: D3SelectedGroup, eMap?: EventMap) {
  if (!eMap) return;
  for (const e of Object.keys(eMap)) {

    group.on(e, null);
  }
}
